export default "__VITE_ASSET__DLm6l6dG__"